import { cn } from "@/lib/utils"
type BrandLogoProps = {
  brand: string
  width?: number
  height?: number
  className?: string
  customLogo?: string | null
  customAlt?: string | null
}
const BrandLogo: React.FC<BrandLogoProps> = ({
  brand,
  width = 150,
  className,
  customLogo,
  customAlt,
}) => {
  const logos = {
    pay2b: "/pay2b_logo.svg",
  } as const
  const src = customLogo || (logos[brand as keyof typeof logos] ?? logos.pay2b)
  const alt = customAlt || `Logo ${brand}`
  return (
    <img
      className={cn("h-auto place-self-center", className)}
      src={src}
      alt={alt}
      width={width}
      style={{ height: "auto" }}
    />
  )
}
export default BrandLogo
